import { render, staticRenderFns } from "./CreateCv.vue?vue&type=template&id=481b4d26&"
import script from "./CreateCv.vue?vue&type=script&lang=js&"
export * from "./CreateCv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports